import { Nav, Navbar} from 'react-bootstrap';
import { NavLink} from "react-router-dom";
import "../../css/common.module.css";
import "../../css/Header.css";
import { useTranslation } from 'react-i18next';
import Logo from '../../images/IDSLogo.png';

function HeaderNoAuth() {
   const { t, i18n } = useTranslation();
	return (
	  <Navbar bg="dark" variant="light" 
	  expand="lg"
	  className={"navbar navbar-expand-lg navbar-light mybgcolor"}
	  >
	   <Navbar.Brand ><img alt="" src={Logo} className="d-inline-block align-top logo"/>{' '}</Navbar.Brand>
	   <div className="px-2"></div>
       
       <Navbar.Collapse id="basic-navbar-login" className="navbar-login">
            <Nav className="ml-auto" >
                <NavLink className="nav-link text-light navlogin-bg " to="/Login"><span className="fa fa-sign-in"> </span>
	                {t("header.login")}
                </NavLink>
            </Nav>
        </Navbar.Collapse>
      </Navbar>
	);
}

export default HeaderNoAuth;
